import React from "react"
import AboutYou from "./aboutyou/AboutYou"
import { Redirect, Route, Switch, withRouter } from "react-router-dom"
import AboutYourPartner from "./AboutYourPartner"
import FleDone from "./FleDone"
import { fleFormTheme } from "themes/formThemes"
import { ThemeProvider } from "styled-components"
import { useBodyClass } from "utils/Hooks"
import { JourneyRouter } from "components/views/fle/journey/JourneyRouter"

const FleRouter = withRouter(() => {
  useBodyClass("bg-warm-gray")

  return (
    <ThemeProvider theme={fleFormTheme}>
      <Switch>
        <Route exact path="/fle">
          <Redirect to="/fle/about-you" />
        </Route>
        <Route path="/fle/about-you">
          <AboutYou />
        </Route>
        <Route path="/fle/partner">
          <AboutYourPartner />
        </Route>
        <Route path="/fle/journey">
          <JourneyRouter />
        </Route>
        <Route path="/fle/done">
          <FleDone />
        </Route>
      </Switch>
    </ThemeProvider>
  )
})

export { FleRouter }
